'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureGroupGroupings(code, selected) {
  this.Yu = null;
  this.Yv = null;
  this.Yu = code;
  this.Yv = selected;
}
export { $c_Lpresto_types$proto$ConfigureGroupGroupings as $c_Lpresto_types$proto$ConfigureGroupGroupings };
$p = $c_Lpresto_types$proto$ConfigureGroupGroupings.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureGroupGroupings;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureGroupGroupings() {
}
export { $h_Lpresto_types$proto$ConfigureGroupGroupings as $h_Lpresto_types$proto$ConfigureGroupGroupings };
$h_Lpresto_types$proto$ConfigureGroupGroupings.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$ConfigureGroupGroupings)) {
    if ((this.Yu === x$0.Yu)) {
      var x = this.Yv;
      var x$2 = x$0.Yv;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ConfigureGroupGroupings";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Yu;
  }
  if ((n === 1)) {
    return this.Yv;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$ConfigureGroupGroupings(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kB)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureGroupGroupings as $isArrayOf_Lpresto_types$proto$ConfigureGroupGroupings };
var $d_Lpresto_types$proto$ConfigureGroupGroupings = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureGroupGroupings, "presto.types$proto$ConfigureGroupGroupings", ({
  kB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureGroupGroupings as $d_Lpresto_types$proto$ConfigureGroupGroupings };
//# sourceMappingURL=presto.types$proto$-Configure-Group-Groupings.js.map
